<template>
  <div
    class="home"
    :style="{
      backgroundImage: 'url(' + img + ')',
      backgroundSize: '100% 100%',
      width: '100%',
      height: '100%',
      position: 'absolute',
    }"
  >
    <div style="width: 100%; margin-top: 10vh">
      <img
        alt="Vue logo"
        style="width: 80%; max-width: 300px"
        src="../assets/logo.png"
      />
    </div>
    <div
      style="
        background-color: #fff;
        width: 80%;

        max-width: 500px;
        margin: 0 auto;
        border-radius: 10px;
        margin-top: 5vh;
        padding: 10px 20px;
      "
    >
      <el-form ref="form" :label-position="'top'" label-width="80px">
        <el-form-item label="账号">
          <el-input v-model="account"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="password" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="width: 100%"
            @click="submitForm('form')"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  components: {},
  data() {
    return {
      img: require("../assets/login_app_bg.png"),
      account: "",
      password: "",
    };
  },
  methods: {
    async submitForm() {
      var data = await this.$api.request.post("/staff/login", {
        account: this.account,
        password: this.password,
      });

      this.$api.success("登录成功");
      localStorage.setItem("uid", data.loginid);
      localStorage.setItem(
        "uinfo",
        JSON.stringify({ name: data.name, role: data.role, roles: data.roles })
      );

      this.$router.replace("/");
    },
  },
};
</script>
